export default __webpack_public_path__ + "static/media/44_photo.85a80017.jpg";